import { isNotNull } from "../common/utils";

export const LoadingReducer = (state = false, action) => {
    switch (action.type) {
        case "UPDATE_LOADING":
            console.log("SET LOADING in REDUCER to " + action.payload);

            let modalList = document.querySelectorAll(".ReactModalPortal");
        
            if (action.payload) {
                console.log("modalList disable: " + JSON.stringify(modalList));
                if (isNotNull(modalList)) {
                    console.log("modalList classList: " + JSON.stringify(modalList.length));
                    modalList.forEach(element => {
                        element.classList.add("blur-container");
                    });
                }
            } else {
                console.log("modalList enable: " + JSON.stringify(modalList));
                if (isNotNull(modalList)) {
                    console.log("modalList classList: " + JSON.stringify(modalList.length));
                    modalList.forEach(element => {
                        element.classList.remove("blur-container");
                    });
                }
            }
            return state = action.payload;
        default:
            return state;
    }
}

export default LoadingReducer;